import { useDialog } from "@apac/hooks";
import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTrigger,
  Icon,
} from "@b2bportal/core-ui/overridable";
import { useI18nContext } from "@hopper-b2b/i18n";
import { ProductType } from "@hopper-b2b/types";
import { CarBookingSummaryContent } from "./components/CarBookingSummaryContent";
import { HotelsBookingSummaryContent } from "./components/HotelsBookingSummaryContent";
import { PriceBreakdownContent } from "./components/PriceBreakdownContent";
import styles from "./styles.module.scss";

export const BookingSummary = ({
  productType,
}: {
  productType: ProductType;
}) => {
  const { t } = useI18nContext();
  const priceDropDialogProps = useDialog();
  const [, cn] = useModuleBEM(styles, "BookingSummary");

  return (
    <Dialog {...priceDropDialogProps}>
      <DialogTrigger>
        <Icon iconName={IconNameEnum.priceBreakdown}></Icon>
      </DialogTrigger>

      <DialogContent title={t("bookingSummary.title")}>
        {productType === ProductType.FLIGHTS ? (
          <PriceBreakdownContent />
        ) : productType === ProductType.LODGING ? (
          <HotelsBookingSummaryContent />
        ) : (
          <CarBookingSummaryContent />
        )}

        <DialogClose className={cn("close-button")}>
          {t("close.button")}
        </DialogClose>
      </DialogContent>
    </Dialog>
  );
};
